import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { StyledRow, StyledCell } from './styled';

import { compose, withHandlers } from 'recompose';
import { getShipperOrder } from 'redux/modules/shipper-orders/selectors';

const enhance = compose(
  connect((state, ownProps) => ({
    item: ownProps.item || getShipperOrder(state, ownProps.itemId),
  })),
  withHandlers({
    handleClick:
      ({ onClick, itemId }) =>
      (e) => {
        if (!itemId || !onClick) {
          return;
        }

        onClick(e, itemId);
      },
  })
);

const TableRow = React.memo(({ item, style, onClick, handleClick, tableCellsConfig = [], ref }) => {
  if (!item) {
    return null;
  }

  return (
    <StyledRow style={style} onClick={handleClick} clickable={onClick}>
      {tableCellsConfig.map(
        (
          {
            props = {},
            cellProps = {},
            children: Children = () => {
              /*noop*/
            },
            component: Component = StyledCell,
          },
          key
        ) => (
          <Component {...props} {...cellProps} key={key}>
            <Children item={item} ref={ref} />
          </Component>
        )
      )}
    </StyledRow>
  );
});

const tableRowHeight = 64;

TableRow.propTypes = {
  item: PropTypes.object,
  style: PropTypes.object,
  handleClick: PropTypes.func,
  onClick: PropTypes.func,
  tableCellsConfig: PropTypes.array,
  ref: PropTypes.any,
};

export default enhance(TableRow);
export { tableRowHeight };
